import { colorsPalettes } from "@similarweb/styles";

import { getSignalEventPeriod } from "app/pages/sales-intelligence/modules/company-analysis/services/signals/getters/getSignalEventDate";
import signalEventsService from "app/pages/sales-intelligence/modules/company-analysis/services/signals/signalEventsService";
import type { TechnologySignalEventDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";
import TruncatedTextWithTooltip from "app/pages/sales-intelligence/pages/company-analysis/components/shared/TruncatedTextWithTooltip/TruncatedTextWithTooltip";
import TechnologyChangesType from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologyChangesType";

type TechnologySignalEventInfoProps = {
    signal: TechnologySignalEventDto;
    companyName: string;
};

const TechnologySignalEventInfoBox = ({ signal, companyName }: TechnologySignalEventInfoProps) => {
    const { technologies, periodDays, changeType } = signal;

    let text = "";

    if (technologies.length === 1 && changeType === TechnologyChangesType.Removed && !!periodDays) {
        text = `${technologies[0]} was installed for ${getSignalEventPeriod(periodDays)}`;
    }

    if (changeType !== TechnologyChangesType.RenewalComingUp) {
        text = `${signalEventsService.getTechnologySignalEventText(signal, companyName)} ${technologies.join(", ")}`;
    }

    if (!text) {
        return null;
    }

    return (
        <TruncatedTextWithTooltip
            height={32}
            text={text}
            textStyles={{
                fontVariant: "input2",
                color: colorsPalettes.carbon[300],
            }}
        />
    );
};

export default TechnologySignalEventInfoBox;
